// eslint-disable-next-line import/no-cycle
import * as widgets from './widgets';
import * as weather from './weatherstack';

export const getWidget = id => widgets.default[id];

export const getWeatherIcon = code => weather.default[code];

export const getSimbleLogo = () => 'https://simble-sense.s3.ap-southeast-2.amazonaws.com/image/buildings/5d312dc3039fa.png';

export const getSpecialLogo = (logo) => {
  // const defaultLogo =
  //   "https://simble-sense.s3.ap-southeast-2.amazonaws.com/image/buildings/5d312dc3039fa.png";
  const buildingId = window.location.pathname.split('/').pop() || 41;
  if (buildingId == 401) {
    return undefined;
    // return defaultLogo;
    // return undefined;
  }

  return logo;
};

export const isMiddyBuilding = () => {
  const buildingId = window.location.pathname.split('/').pop() || 41;
  if (buildingId == 401) {
    return true;
  }

  return false;
};

export const isPowercorBuilding = () => {
  const buildingId = window.location.pathname.split('/').pop() || 41;
  if (buildingId == 15) {
    return true;
  }

  return false;
};
